export default __webpack_public_path__ + "static/assets/73986486a1a4556df53608a2d763ffbf.png";